import React from "react"
import "../CSS/previous_edition.css"
import NavBar from "../Components/NavBar"
import {CINS_2024_LINK, IEEE_LOGO} from "../Constants"


let Previous_Edition_2024 = () => {
    
    return (
        <>  

            <NavBar></NavBar>
            <section className = "previous-edition-heading-section">
                <h1 className = "roboto-condensed-700">2024 International Conference on Computational Intelligence and Network Systems (CINS)</h1>
                <h2 className = "roboto-condensed-300">Dubai, United Arab Emirates, October 28–29, 2024, Proceedings</h2>
            </section>

            <section className = "publisher-section">
                <h2 className = "roboto-condensed-700">Publisher</h2>


                <img src = {IEEE_LOGO}></img>
            </section>

            <a className = "pdf-item" href = {CINS_2024_LINK} style = {{textAlign : "center", color : "black", textDecoration : "none"}}><h3 className = "roboto-condensed-700">Click Here To View Conference Proceedings</h3></a>
        </>
    )
} 

export default Previous_Edition_2024